import type { Question } from '@app/src/types/resourceExplorer'

export interface QuestionnaireReference {
  id: number
  title: string
}

// Derives the distinct questionnaires a question currently belongs to, from its included sections.
// A question can sit in several sections of the same questionnaire, so results are deduped by questionnaire id.
export const getQuestionQuestionnaires = (question: Question): QuestionnaireReference[] => {
  const byId = new Map<number, QuestionnaireReference>()

  question.sections?.forEach(section => {
    const template = section.questionnaireTemplate
    if (!template?.title) return

    if (!byId.has(template.id)) {
      byId.set(template.id, { id: template.id, title: template.title })
    }
  })

  return Array.from(byId.values()).sort((a, b) => a.title.localeCompare(b.title))
}
